<template>
    <div class="area-analysis flow-container">
        <ParamsHeader @searchParams="searchData" :data-conf="{ type: 'year' }"></ParamsHeader>
        <Card :no-border="false" style="margin-top: 15px">
            <template #header>
                <div class="card-header">
                    <span>节假日趋势</span>
                </div>
            </template>
            <div style="padding: 0px 20px 20px; margin-top: 20px">
                <div style="margin-right: 10px">
                    <ChartMap class="chart-normal" ref="first-chart"></ChartMap>
                </div>
            </div>
        </Card>
        <Card :no-border="false" style="margin-top: 15px">
            <template #header>
                <div class="card-header">
                    <span>节假日对标</span>
                </div>
            </template>
            <div style="padding: 0px 20px 20px; display: flex; margin-top: 20px">
                <div style="flex: 1">
                    <ChartMap class="chart-normal" ref="second-chart"></ChartMap>
                </div>
                <div style="flex: 1">
                    <ChartMap class="chart-normal" ref="third-chart"></ChartMap>
                </div>
            </div>
        </Card>
    </div>
</template>

<script>
import ParamsHeader from "../components/ParamsHeader2";

export default {
    name: "holiday",
    components: {
        ParamsHeader,
    },
    data() {
        return {
            searchParam: null,
            barData: null,
        };
    },
    methods: {
        searchData(params) {
            let searchParam = {
                BeginYear: params.Date,
                EndYear: params.Date,
                EntityID: params.EntityID,
            };
            this.searchParam = { ...searchParam };
            this.$ajax.post("/AnalyzeData/GetMutliHolidayTotal", params).then((res) => {
                const data = res.Data;
                if (Array.isArray(data)) {
                    this.barData = data;
                    this.buildChart();
                }
            });
        },
        buildChart() {
            let firstChart = this.firstChart();
            firstChart ? this.$refs["first-chart"].setData(firstChart) : this.$refs["first-chart"].noData();
            //let secondChart = this.secondChart();
            this.$refs["second-chart"].noData();
            let thirdChart = this.thirdChart();
            this.$refs["third-chart"].setData(thirdChart);
        },
        firstChart() {
            if (!this.barData.length) return false;
            let xAxisData = this.barData.map((item) => item.Name);
            let flow = this.barData.map((item) => item.DataIn);
            let option = {
                color: ["#5B9BD5", "#ED7D31"],
                tooltip: {
                    show: true,
                    showContent: true,
                    trigger: "axis",
                },
                title: {
                    text: "节假日效应",
                    left: "center",
                },
                legend: {
                    bottom: 15,
                    data: ["节假日客流量", "节假日效应"],
                },
                grid: {
                    top: 50,
                    left: "3%",
                    right: "4%",
                    bottom: 50,
                    containLabel: true,
                },
                xAxis: {
                    type: "category",
                    boundaryGap: true,
                    data: xAxisData,
                    axisLine: {
                        show: false,
                        onZero: true,
                    },
                    axisTick: {
                        show: false,
                    },
                },
                yAxis: [
                    {
                        type: "value",
                        scale: true,
                        // min: -150,
                        // max: 150,
                        // interval: 50,
                    },
                    // {
                    //     type: "value",
                    //     scale: true,
                    //     min: -30,
                    //     max: 30,
                    //     interval: 10,
                    //     axisLine: {
                    //         onZero: true,
                    //     },
                    // },
                ],
                series: [
                    {
                        name: "节假日客流量",
                        data: flow,
                        type: "bar",
                    },
                    // {
                    //     name: "节假日效应",
                    //     data: [-2.0, -2.2, -3.3, -4.5, 6.3, -10.2, -20.3, -23.4, -23.0, -16.5],
                    //     type: "line",
                    //     yAxisIndex: 1,
                    // },
                ],
            };
            return option;
        },
        secondChart() {
            let option = {
                color: ["#4472C4", "#FFC000", "#A5A5A5", "#ED7D31", "#CCCCCC"],
                title: {
                    text: "节假日效应对标",
                    left: "center",
                },
                legend: {
                    right: 30,
                    bottom: 10,
                    orient: "vertical",
                    data: ["华北区", "华南区", "华东区", "华中区"],
                },
                grid: {
                    top: 80,
                    left: "3%",
                    right: "4%",
                    containLabel: true,
                },
                radar: {
                    // shape: 'circle',
                    center: ["50%", "60%"],
                    indicator: [
                        { name: "元旦", max: 6500 },
                        { name: "圣诞", max: 16000 },
                        { name: "双十一", max: 30000 },
                        { name: "国庆", max: 38000 },
                        { name: "劳动节", max: 52000 },
                    ],
                },
                series: [
                    {
                        type: "radar",
                        data: [
                            {
                                value: [4200, 3000, 20000, 35000, 50000],
                                name: "华北区",
                            },
                            {
                                value: [5000, 14000, 28000, 26000, 42000],
                                name: "华南区",
                            },
                            {
                                value: [2200, 4000, 16000, 38000, 40000],
                                name: "华东区",
                            },
                            {
                                value: [6000, 13000, 25000, 30000, 42000],
                                name: "华中区",
                            },
                        ],
                    },
                ],
            };
            return option;
        },
        thirdChart() {
            let option = {
                color: ["#4472C4", "#FFC000", "#A5A5A5", "#ED7D31", "#CCCCCC"],
                title: {
                    text: "节假日客流对标",
                    left: "center",
                },
                legend: {
                    right: 30,
                    bottom: 10,
                    orient: "vertical",
                    data: ["华北区", "华南区", "华东区", "华中区"],
                },
                grid: {
                    left: "3%",
                    right: "4%",
                    bottom: 0,
                    containLabel: true,
                },
                radar: {
                    // shape: 'circle',
                    center: ["50%", "60%"],
                    indicator: [
                        { name: "元旦", max: 6500 },
                        { name: "圣诞", max: 16000 },
                        { name: "双十一", max: 30000 },
                        { name: "国庆", max: 38000 },
                        { name: "劳动节", max: 52000 },
                    ],
                },
                series: [
                    {
                        type: "radar",
                        data: [
                            {
                                value: [4200, 3000, 20000, 35000, 50000],
                                name: "华北区",
                            },
                            {
                                value: [5000, 14000, 28000, 26000, 42000],
                                name: "华南区",
                            },
                            {
                                value: [2200, 4000, 16000, 38000, 40000],
                                name: "华东区",
                            },
                            {
                                value: [6000, 13000, 25000, 30000, 42000],
                                name: "华中区",
                            },
                        ],
                    },
                ],
            };
            return option;
        },
    },
};
</script>

<style scoped></style>
